import { useEffect, useState } from 'react';

export interface ZzzfunDownloadConfig {
  android: string;
  ios: string;
  harmonyos: string;
  windows: string;
}

export interface ZzzfunConfig {
  officialSite: string;
  contactEmail: string;
  download: ZzzfunDownloadConfig;
}

export const zzzfunDefaultConfig: ZzzfunConfig = {
  officialSite: 'https://www.zzzfun.net',
  contactEmail: 'txby666666@163.com',
  download: {
    android: 'https://www.zzzfun.net',
    ios: 'https://www.zzzfun.net',
    harmonyos: 'https://www.zzzfun.net',
    windows: 'https://www.zzzfun.net',
  },
};

/**
 * 读取外置 JSON 配置（public/zzzfun-config.json）。
 * 修改下载链接 / 联系邮箱时只需编辑该 JSON，无需重新打包。
 */
export function useZzzfunConfig(): ZzzfunConfig {
  const [config, setConfig] = useState<ZzzfunConfig>(zzzfunDefaultConfig);

  useEffect(() => {
    let active = true;
    const url = `${import.meta.env.BASE_URL}zzzfun-config.json`;

    fetch(url, { cache: 'no-store' })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!active || !data || typeof data !== 'object') return;
        setConfig({
          officialSite:
            typeof data.officialSite === 'string'
              ? data.officialSite
              : zzzfunDefaultConfig.officialSite,
          contactEmail:
            typeof data.contactEmail === 'string'
              ? data.contactEmail
              : zzzfunDefaultConfig.contactEmail,
          download: {
            android: data?.download?.android || zzzfunDefaultConfig.download.android,
            ios: data?.download?.ios || zzzfunDefaultConfig.download.ios,
            harmonyos: data?.download?.harmonyos || zzzfunDefaultConfig.download.harmonyos,
            windows: data?.download?.windows || zzzfunDefaultConfig.download.windows,
          },
        });
      })
      .catch(() => {
        // 配置读取失败时使用默认值，保证页面可用
      });

    return () => {
      active = false;
    };
  }, []);

  return config;
}